import { Options } from "common";
import api from "app/api";
export enum IntegrationType {
  OneDrive = "ONEDRIVE",
  GoogleDrive = "GOOGLE_DRIVE",
  Dropbox = "DROPBOX",
  Email = "MAIL",
  MailChimp = "MAILCHIMP",
  Ftp = "FTP",
  Smtp = "SMTP",
}

export enum IntegrationStatus {
  New = "NEW",
  Connected = "CONNECTED",
  NotConnected = "NOT_CONNECTED",
  Revoked = "REVOKED",
}
export type IntegrationFields =
  | "id"
  | "status"
  | "enabled"
  | "name"
  | "type"
  | "account_id"
  | "options"
  | "created_at"
  | "created_by"
  | "deleted_at"
  | "deleted_by"
  | "location_ids"
  | "locations"
  | "filename_format"
  | "directory"
  | "api_key"
  | "email"
  | "subject"
  | "message"
  | "from_name"
  | "from_email"
  | "host"
  | "username"
  | "password"
  | "port"
  | "ssl"
  | "protocol"
  | "passive";

export type IntegrationListItem = {
  id: number;
  status: IntegrationStatus;
  enabled: number; //boolean
  name: string;
  type: IntegrationType;
  account_id?: number;
  options?: object;
  created_at?: string;
  created_by?: number;
  deleted_at?: string;
  deleted_by?: number;
  location_ids?: number[];
  locations?: string[];
  filename_format?: string;
  directory?: string;
  api_key?: string;
  email?: string;
  subject?: string;
  message?: string;
  from_name?: string;
  from_email?: string;
  host?: string;
  username?: string;
  password?: string;
  port?: number;
  ssl?: boolean; //boolean
  passive?: number; //boolean
  protocol?: string;
};
export type IntegrationFormItem = {} & IntegrationListItem;

export type IntegrationOptions = Options<"status" | "type" | "location_ids">;

export function getIntegrationService() {
  return api.getService<
    IntegrationFormItem,
    IntegrationListItem,
    IntegrationOptions
  >("integrations");
}

export async function integrationTest(integration_id: number) {
  const { success, data, error } = await api.get(
    `/integrations/test/${integration_id}`
  );

  if (success && !!data?.success) {
    return true;
  }
  return false;
}
